import { render, staticRenderFns } from "./BrandsByStateCategoryDonutChart.vue?vue&type=template&id=15418eb0&scoped=true&"
import script from "./BrandsByStateCategoryDonutChart.vue?vue&type=script&lang=ts&"
export * from "./BrandsByStateCategoryDonutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15418eb0",
  null
  
)

export default component.exports